<div class="field field-select field-typeahead position-relative" [class.valid]="localModel">
  @if (label) {
    <span class="label">{{label}} @if (optionalString) {
      <span>({{optionalString}})</span>
    }</span>
  }
  <div [class.disabled-wrap]="disabled">
    <div class="typeahead-wrap" [class.open]="isOpen()">
      <input id="typeahead-prevent-manual-entry_{{index}}"
        type="text"
        autocomplete="off"
        placement="bottom-left"
        [class.error-field]="error"
        [placeholder]="placeholder"
        [(ngModel)]="localModel"
        (blur)="onBlur()"
        (focus)="!localModel && focus$.next($any($event).target.value)"
        (selectItem)="onSelect($event)"
        [ngbTypeahead]="search"
        [inputFormatter]="formatter"
        [resultFormatter]="formatter"
        [resultTemplate]="template"
        (change)="change($event)"
        autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
        [editable]="editable" />
      <div class="fill"></div>
    </div>
  </div>
  @if (error) {
    <span class="error-field-display">{{error}}</span>
  }

  <ng-template #template let-r="result" let-t="term">
    <div [title]="r?.title">
      <ngb-highlight [result]="r.title" [term]="t"></ngb-highlight>
    </div>
    @if (afterARR && afterARR.length) {
      <span class="typeahead-after">
        @for (item of afterARR; track item; let $i = $index) {
          @if (r[item]) {
            @if (!r[item].type) {
              @if ($i) {
                -
                }{{r[item]}}
              }
              @if (r[item].type === 'arrayTooltip') {
                {{r[item].subtitle}}@if (r[item].stamp) {
                <span class="stamp ml-xxs">{{r[item].stamp}}</span>
              }
            }
          }
        }
      </span>
    }
  </ng-template>
</div>